import {Component} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {EventsService} from "app/lib/EventsService";
import {BaseComponent} from "app/views/base.component";
import {ModalService} from "../../views/modal/base_modal.component";
import {FriendDetailsComponent} from "./details/friend_details.component";
import { BillingService2 } from "../billing.service";
import { HelperService } from "../../lib/helper.service";
import { IStatResult, ITotals } from "../../models/responce_result.model";


interface PromocodeResult extends IStatResult, ITotals {}

interface IFriendTotal {
	paidCount: number;
	userCount: number;
	paidUserCount: number;
}

@Component({
	selector: 'friend',
	templateUrl: './friend.component.html'
})
export class FriendComponent extends BaseComponent {
	rows;
	
	listLoader = false;

	addFilterParams = {
		userType: 'user',
		isExpiredPaid: true,
		dateFilters: ['datePaid', 'dateCreated', 'dateSiteCreated']
	};
	
	total = {
		paidCount: 0,
		userCount: 0,
		paidUserCount: 0
	};
	
	sort = {
		field: 'paidUserCount',
		desc: true
	};

	constructor(
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public filter: FilterFormService,
		public eventsService: EventsService,
		public modalService: ModalService,
		public service2: BillingService2,
		public helper: HelperService,
	) {
		super(eventsService, service2, activatedRoute, filter, translate);
	}

	async getData() {
		await this.getList();
	}

	async getList() {
		this.rows = [];
		
		this.listLoader = true;
		
		const { stats, totals } =  await this.service2.promocode.get<PromocodeResult>(
			this.filter.getFilterParams(),
			'friend/stats',
		).toPromise();

		this.rows = stats;
		this.total = <IFriendTotal>totals;
		
		this.listLoader = false;
	}
	
	getSortArrows(field) {
		if (this.sort.field !== field) {
			return '⇅';
		} else {
			return this.sort.desc ? '↓' : '↑';
		}
	}

	getSort(field) {
		let me = this;
		
		if (me.sort.field !== field) {
			me.sort.desc = true;
			me.sort.field = field;
		} else {
			me.sort.desc = !me.sort.desc;
		}

		me.rows.sort((a, b) => {
			if(me.sort.desc) {
				return b[me.sort.field] - a[me.sort.field];
			} else {
				return a[me.sort.field] - b[me.sort.field];
			}
		});
	}

	async showDetails(i: number) {
		let row = this.rows[i];
		const modalRef = this.modalService.open(
			FriendDetailsComponent,
			{
				title: row.promoMark,
				translate: this.translate
			},
			{size: 'lg'}
		);

		modalRef.componentInstance.userList = row.userList;
	}
}
